var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tsBar flex", class: { show: !_vm.isFold } },
    [
      _c("img", {
        attrs: { src: require("images/granary/ts-bar-bg4.png"), alt: "" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }